import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';

import { CalendarViewType } from '../../../hooks/use-schedule-calendar.hook';

export type { CalendarViewType };

type CalendarViewToggleProps = {
  value: CalendarViewType;
  onChange: (value: CalendarViewType) => void;
};

export const CalendarViewToggle = ({ value, onChange }: CalendarViewToggleProps) => {
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: CalendarViewType | null,
  ) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size='small'
      color='primary'
      sx={{
        '& .MuiToggleButton-root': {
          borderColor: 'primary.main',
          color: 'primary.main',
          '&.Mui-selected': {
            backgroundColor: '#E1E0F6',
            color: 'primary.main',
          },
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        },
      }}
    >
      <ToggleButton value='week'>
        <CalendarViewWeekIcon sx={{ mr: 0.5 }} />
        Week
      </ToggleButton>
      <ToggleButton value='day'>
        <CalendarViewDayIcon sx={{ mr: 0.5 }} />
        Day
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
